var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrhuHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21",
    "data-name": "Group 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.832,
    height: 36.754,
    viewBox: "0 0 127.832 36.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M110.041.306v14.17H97V.306H87.156V36.581H97V22.411h13.036v14.17h9.848V.306Z",
    transform: "translate(-26.778 -0.094)",
    fill: "#2a4a4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M160.79.077h9.848V23.315a12.794,12.794,0,0,1-1.975,7.165,12.883,12.883,0,0,1-5.5,4.658,21.337,21.337,0,0,1-16.4,0,12.373,12.373,0,0,1-7.439-11.823V.077h9.848V22.465a6.005,6.005,0,0,0,.744,3,5.331,5.331,0,0,0,2.063,2.064,6.448,6.448,0,0,0,6.014,0,5.352,5.352,0,0,0,2.055-2.064,6.005,6.005,0,0,0,.743-3Z",
    transform: "translate(-42.806 -0.024)",
    fill: "#2a4a4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M10.628,36.275H0V0H11.265a17.3,17.3,0,0,1,8.883,2.161,14.181,14.181,0,0,1,5.659,6.2,21.948,21.948,0,0,1,1.967,9.689,21.947,21.947,0,0,1-2.011,9.786A14.253,14.253,0,0,1,19.918,34.1a18.529,18.529,0,0,1-9.29,2.179M3.312,33.3h7.121a15.3,15.3,0,0,0,7.829-1.842A11.512,11.512,0,0,0,22.99,26.2a19.311,19.311,0,0,0,1.577-8.147,19.662,19.662,0,0,0-1.55-8.077,11.337,11.337,0,0,0-4.535-5.19A14.147,14.147,0,0,0,11.07,2.975H3.312Z",
    transform: "translate(0 0)",
    fill: "#2a4a4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M70.148,36.275,61.774,20.923a10.389,10.389,0,0,0,1.626-.678,9.2,9.2,0,0,0,3.905-3.79,11.531,11.531,0,0,0,1.32-5.6A11.686,11.686,0,0,0,67.3,5.234,9.313,9.313,0,0,0,63.391,1.39,13.548,13.548,0,0,0,56.935,0H45.226V36.275h3.313V21.609h8.449c.478,0,.937-.021,1.386-.053l7.949,14.719ZM56.9,18.58h-8.36V2.975h8.308a10.318,10.318,0,0,1,4.756.974A6.447,6.447,0,0,1,64.427,6.7a8.775,8.775,0,0,1,.939,4.154,8.587,8.587,0,0,1-.93,4.109,6.251,6.251,0,0,1-2.817,2.675,10.555,10.555,0,0,1-4.72.939",
    transform: "translate(-13.895 0)",
    fill: "#2a4a4f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrhuHeader);
export default __webpack_public_path__ + "static/media/DRHUHeader.cfc50a63d90ae8f415cd10910305269a.svg";
export { ForwardRef as ReactComponent };